module.exports = __webpack_public_path__ + "img/table.c76c4e83.png";